import React from 'react'
import BaseButton from 'shared/components/button/components/base-button'
import { ButtonType } from 'shared/components/button/types/button-interface'

const SuccessButton = (props: ButtonType) => (
  <BaseButton
    color={'text-background-secondary'}
    hoverColor={'hover:text-background-secondary'}
    backgroundColor={'bg-green'}
    hoverBackgroundColor={'hover:bg-green'}
    {...props}
  />
)
export default SuccessButton
